module.exports = __webpack_public_path__ + "img/frame-browser-foujita-long-ja.d8d0901d.jpg";